
import {
  Vue,
  Component,
  Watch,
  Prop,
  Model,
  Emit,
  Ref,
} from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import { IImage } from '@/common/interface';
import SPUService from '@/services/spu.service';
import ImageIibraryModal from './ImageIibraryModal.vue';
import { DebounceTime } from '@/common/decorator';

@Component({
  components: {
    ImageIibraryModal,
  },
})
export default class HeadlineImageField extends Vue {
  val: IImage = {
    id: 0,
    url: '',
  };

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @Ref('imageIibraryModal')
  imageIibraryModal!: ImageIibraryModal;

  uploading = false;

  BASE_URL = BASE_URL;

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  token: string | undefined = undefined;

  @Prop()
  placeholder?: string;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  refs!: any;

  @Prop()
  form!: any;

  @Model()
  value!: IImage;

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = { ...this.value };
    } else {
      this.val = { id: 0, url: '' };
    }
  }

  @Emit('update')
  updateVal() {
    console.log('updateVal', this.val);
    return this.val;
  }

  oldId = 0;

  objDate: any = {};

  objPhoto: any = [];

  changeKey: any = '';

  radioValue = 0;

  @DebounceTime()
  @Watch('form.category')
  async watchCategory() {
    if (!this.form) {
      return;
    }
    console.log('watchCategory', this.form);
    if (this.oldId !== this.form.category.id) {
      this.oldId = this.form.category.id;
      const { category } = this.form;
      const res: any = await this.spuService.getSpuCategoryPhotoDelete(
        category.id,
      );
      const findDefaultItem = (obj: any): { is_default: 1 } | null => {
        if (!obj || typeof obj !== 'object') return null;
        const values = Object.values(obj).filter(Array.isArray).flat();
        return (
          values.find(
            (item): item is { is_default: 1 } =>
              item != null && typeof item === 'object' && item.is_default === 1,
          ) || null
        );
      };
      if (Object.prototype.toString.call(res) === '[object Object]') {
        const keys = Object.keys(res) as string[];
        const re = JSON.parse(JSON.stringify(res));
        const defaultItem: any = findDefaultItem(re);
        if (defaultItem && !this.form.id) {
          const { url, resource_id } = defaultItem;
          const result = {
            id: resource_id,
            url,
          };
          this.val = { ...result };
          this.updateVal();
          this.radioValue = resource_id;
        }
        this.objPhoto = keys;
        this.changeKey = defaultItem
          ? defaultItem.photo_type_name
          : keys[0] || '';
        this.objDate = res;
      } else {
        // this.val = { id: 0, url: '' };
        this.objPhoto = [];
        this.changeKey = '';
        this.objDate = {};
      }
    }
  }

  @lazyInject(UserService)
  protected userService!: UserService;

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }

  funChange(item: any) {
    this.changeKey = item;
  }

  onRadioChange(e: any) {
    const id = e.target.value;
    const data = this.objDate[this.changeKey];
    const photo = data.find((item: any) => item.resource_id === id);
    const { url, resource_id } = photo;
    const result = {
      id: resource_id,
      url,
    };
    this.val = { ...result };
    this.updateVal();
    this.radioValue = id;
    console.log(photo);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      this.radioValue = 0;
      const result = {
        id: data[0]?.id,
        url: data[0]?.url,
      };
      this.val = { ...result };
      this.updateVal();
      this.uploading = false;
    }
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  mounted() {
    this.watchValue();
    this.watchCategory();
  }
}
